import React, { useEffect, useState } from "react";
import { authFetch } from "../../api/api";
import { useTranslation } from "react-i18next";


const BASE_URL = process.env.REACT_APP_DJANGO_BACKEND;
const API_URL = `${BASE_URL}/api/orders/`;


export default function ExtraExpensesModal({
  orderId,
  expense,
  onClose,
  onSuccess,
}) {

  const { t } = useTranslation("OrdersPage");


  const [title, setTitle] = useState("");
  const [priceClient, setPriceClient] = useState("");
  const [priceInternal, setPriceInternal] = useState("");
  const [comment, setComment] = useState("");



  // ===============================
  // Загрузка данных при редактировании
  // ===============================
  useEffect(() => {

    if (expense) {

      setTitle(expense.title || "");

      setPriceClient(
        expense.price_client || ""
      );

      setPriceInternal(
        expense.price_internal || ""
      );

      setComment(
        expense.comment || ""
      );

    } else {

      // очистка при добавлении

      setTitle("");
      setPriceClient("");
      setPriceInternal("");
      setComment("");

    }

  }, [expense]);




  // ===============================
  // SAVE / UPDATE
  // ===============================
  const handleSave = async () => {

    try {


      const url = expense
        ? `${API_URL}${orderId}/expenses/${expense.id}/`
        : `${API_URL}${orderId}/expenses/`;



      const method = expense
        ? "PATCH"
        : "POST";



      const res = await authFetch(
        url,
        {
          method,

          headers: {
            "Content-Type": "application/json",
          },


          body: JSON.stringify({

            title,

            price_client: Number(priceClient),

            price_internal: Number(priceInternal),

            comment,

          }),
        }
      );



      if (!res.ok) {

        throw new Error(
          t("error_save")
        );

      }



      onSuccess();

      onClose();



    } catch (err) {

      console.error(err);

      alert(
        t("error_save") ||
        "Ошибка при сохранении"
      );

    }

  };




  return (

    <div
      className="
        fixed
        inset-0
        bg-black/40
        flex
        items-center
        justify-center
        z-50
      "
    >


      <div
        className="
          bg-white
          w-[500px]
          p-5
          rounded-lg
          space-y-4
        "
      >


        <h2 className="text-lg font-bold">

          {expense
            ? t("edit_expense")
            : t("add_expense")
          }

        </h2>




        <input

          className="
            w-full
            border
            p-2
            rounded
          "

          placeholder={t("title")}

          value={title}

          onChange={(e)=>
            setTitle(e.target.value)
          }

        />





        <input

          className="
            w-full
            border
            p-2
            rounded
          "

          placeholder={t("price_for_client")}

          value={priceClient}

          onChange={(e)=>
            setPriceClient(e.target.value)
          }

        />





        <input

          className="
            w-full
            border
            p-2
            rounded
          "

          placeholder={t("price_for_us")}

          value={priceInternal}

          onChange={(e)=>
            setPriceInternal(e.target.value)
          }

        />





        <textarea

          className="
            w-full
            border
            p-2
            rounded
          "

          placeholder={t("comment")}

          value={comment}

          onChange={(e)=>
            setComment(e.target.value)
          }

        />





        <div
          className="
            flex
            justify-end
            gap-2
          "
        >



          <button

            className="
              px-4
              py-2
              border
              rounded
            "

            onClick={onClose}

          >

            {t("cancel")}

          </button>





          <button

            className="
              px-4
              py-2
              bg-blue-600
              text-white
              rounded
            "

            onClick={handleSave}

          >

            {expense
              ? t("save")
              : t("add")
            }

          </button>



        </div>


      </div>


    </div>

  );

}